import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { bootstrap } from './init'
import { App } from './root'
import '@fontsource/montserrat/300.css'
import '@fontsource/montserrat/400.css'
import '@fontsource/montserrat/500.css'
import '@fontsource/montserrat/600.css'
import '@/app/styles/index.css'

await bootstrap()

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element #root not found')

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
